<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {    
    this.classList.toggle("active");
    var panel = this.nextElementSibling;   
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

jQuery('.productView-wishlist').appendTo('.custom_product_tmp .halo-productView-right .productView_accordion');
jQuery('<span>Add to Wishlist</span>').appendTo('.custom_product_tmp .halo-productView-right .productView-wishlist');


   if ($(window).width() < 767){
      jQuery('.only_forMobile').show();
      jQuery('.productPriceD').hide();
      jQuery('.productTitleD').hide(); 
     jQuery('.mobile_video').show();
     jQuery('.desktop_video').hide();
    }else{
     jQuery('.only_forMobile').hide();
     jQuery('.productPriceD').show();
      jQuery('.productTitleD').show(); 
     jQuery('.mobile_video').hide();
     jQuery('.desktop_video').show();
    }
